import React from 'react';

const CustomInput = ({
  type = 'text',
  placeholder = '',
  bgColor = 'bg-primary',
  textColor = 'text-white',
  placeholderColor = 'placeholder-[#F0EAF5]/60',
  height = 'h-8',
  width = 'w-full',
  rounded = 'rounded-[4px]',
  customClasses = '',
  ...props
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={`
        ${bgColor} 
        ${textColor} 
        ${placeholderColor} 
        ${height} 
        ${width} 
        ${rounded} 
        px-2 xl:px-3 
        py-2 lg:py-3 2xl:py-4
        focus:outline-none
        ${customClasses}
      `}
      {...props}
    />
  );
};

export default CustomInput;
